<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Dialog Add/Edit -->
    <v-dialog max-width="900px" v-model="dialogAddEdit" persistent>
      <v-card>
        <v-card-title>
          {{ editedItem.id_fiscal_regla === null ? "Crear" : "Editar" }} Regla Fiscal
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- Tipo de Proveedor -->
              <v-col cols="12">
                <v-autocomplete
                  v-model="editedItem.id_proveedor_tipo"
                  :items="proveedorTipos"
                  item-text="nombre"
                  item-value="id_proveedor_tipo"
                  label="Tipo de Proveedor *"
                  outlined
                  dense
                  hide-details
                  @change="onProveedorTipoChange"
                  :loading="loadingProveedorTipos"
                  :disabled="loadingProveedorTipos"
                ></v-autocomplete>
              </v-col>

              <template v-if="editedItem.id_proveedor_tipo != null">
                <!-- Tipo de Persona (solo para Nacional) -->
                <v-col cols="12" md="6" v-if="isProveedorNacional">
                  <v-autocomplete
                    v-model="editedItem.id_persona_tipo"
                    :items="personaTipos"
                    item-text="nombre"
                    item-value="id_persona_tipo"
                    label="Tipo de Persona"
                    outlined
                    dense
                    hide-details
                    clearable
                    @change="onPersonaTipoChange"
                    :loading="loadingPersonaTipos"
                    :disabled="loadingPersonaTipos"
                  ></v-autocomplete>
                </v-col>

                <!-- Régimen Fiscal (solo para Nacional) -->
                <v-col cols="12" md="6" v-if="isProveedorNacional">
                  <v-autocomplete
                    v-model="editedItem.id_regimen_fiscal"
                    :items="regimenesFiscalesFiltrados"
                    item-text="nombre"
                    item-value="id_regimen_fiscal"
                    label="Régimen Fiscal"
                    outlined
                    dense
                    hide-details
                    clearable
                    :disabled="
                      !editedItem.id_persona_tipo || loadingRegimenesFiscales
                    "
                    :loading="loadingRegimenesFiscales"
                  ></v-autocomplete>
                </v-col>

                <!-- Tipo de Gasto (solo para Nacional) -->
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="editedItem.id_gasto_tipo"
                    :items="gastoTipos"
                    :loading="loadingGastoTipos"
                    item-value="id_gasto_tipo"
                    item-text="nombre"
                    dense
                    hide-details
                    outlined
                    label="Tipo de Gasto"
                    :disabled="editedItem.id_gasto_subtipo != null"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>

                <!-- Subtipo de Gasto (solo para Nacional) -->
                <v-col cols="12" md="6">
                  <v-autocomplete-gasto-subtipo
                    v-model="editedItem.id_gasto_subtipo"
                    :items="gastoSubtipos"
                    :loading="loadingGastoSubtipos"
                    :disabled="editedItem.id_gasto_tipo != null"
                  ></v-autocomplete-gasto-subtipo>
                </v-col>
              </template>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editedItem.monto_minimo"
                  label="Monto Mínimo *"
                  type="number"
                  prefix="$"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editedItem.monto_maximo"
                  label="Monto Máximo *"
                  type="number"
                  prefix="$"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete-pago-forma
                  v-model="editedItem.id_pago_forma"
                  :items="pagoFormas"
                  :loading="loadingPagoFormas"
                ></v-autocomplete-pago-forma>
              </v-col>
            </v-row>

            <v-subheader class="px-0 mt-4">Impuestos Aplicables</v-subheader>
            <v-divider class="mb-4"></v-divider>

            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.iva"
                  label="IVA"
                  placeholder="16%"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.isr"
                  label="ISR"
                  placeholder="10%"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editedItem.iva_retencion"
                  label="IVA Retención"
                  placeholder="10.67"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn
            color="red"
            text
            @click="saveDialogAddEdit"
            :loading="loadingSave"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete -->
    <v-dialog max-width="500px" v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title>Eliminar Regla Fiscal</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar esta regla fiscal? Esta acción es
          permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn
            color="red"
            text
            @click="saveDialogDelete"
            :loading="loadingDelete"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Actions Row -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="openDialogAddEdit(null)">
          Nueva Regla Fiscal
        </v-btn>
      </v-col>
    </v-row>

    <!-- Filters Section -->
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="filters.id_gasto_tipo"
          :items="gastoTipos"
          :loading="loadingGastoTipos"
          item-value="id_gasto_tipo"
          item-text="nombre"
          dense
          hide-details
          outlined
          label="Tipo de Gasto"
          :disabled="filters.id_gasto_subtipo != null"
          clearable
        >
        </v-autocomplete>
      </v-col>
      
      <v-col cols="12" md="4">
        <v-autocomplete-gasto-subtipo
          v-model="filters.id_gasto_subtipo"
          :items="gastoSubtipos"
          :loading="loadingGastoSubtipos"
          label="Subtipo de Gasto"
          :disabled="filters.id_gasto_tipo != null"
        ></v-autocomplete-gasto-subtipo>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="filters.id_proveedor_tipo"
          :items="proveedorTipos"
          item-text="nombre"
          item-value="id_proveedor_tipo"
          label="Tipo de Proveedor"
          clearable
          dense
          outlined
          hide-details
          :loading="loadingProveedorTipos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="filters.id_persona_tipo"
          :items="personaTipos"
          item-text="nombre"
          item-value="id_persona_tipo"
          label="Tipo de Persona"
          clearable
          dense
          outlined
          hide-details
          :loading="loadingPersonaTipos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="filters.id_regimen_fiscal"
          :items="regimenesFiscales"
          item-text="nombre"
          item-value="id_regimen_fiscal"
          label="Régimen Fiscal"
          clearable
          dense
          outlined
          hide-details
          :loading="loadingRegimenesFiscales"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete-pago-forma
          v-model="filters.id_pago_forma"
          :items="pagoFormas"
          :loading="loadingPagoFormas"
        ></v-autocomplete-pago-forma>
      </v-col>
      <v-col cols="12" md="3">
        <v-btn
          color="primary"
          text
          outlined
          block
          @click="getItems"
        >
          <v-icon> mdi-magnify </v-icon>
          Buscar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Data Table -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="filteredRules"
          :headers="headers"
          :loading="loading"
          :search="search"
          :items-per-page="10"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        >
          <!-- Custom slots -->
          <template v-slot:[`item.id_proveedor_tipo`]="{ item }">
            <v-chip
              small
              :color="getProveedorColor(item.id_proveedor_tipo)"
              text-color="white"
            >
              {{ item.nombre_proveedor_tipo }}
            </v-chip>
          </template>

          <template v-slot:[`item.id_persona_tipo`]="{ item }">
            {{item.nombre_persona_tipo || '-'}}
          </template>

          <template v-slot:[`item.id_regimen_fiscal`]="{ item }">
            {{ item.nombre_regimen_fiscal || '-' }}
          </template>

          <template v-slot:[`item.id_gasto_subtipo`]="{ item }">
            <strong>{{ item.nombre_gasto_tipo || '-' }}</strong>
            <template v-if="item.nombre_gasto_subtipo != null">
              -
              {{ item.nombre_gasto_subtipo || '-' }}
            </template>
          </template>

          <template v-slot:[`item.montos`]="{ item }">
            <div class="text-no-wrap">
              <small class="grey--text">Min:</small> ${{
                formatNumber(item.monto_minimo)
              }}<br />
              <small class="grey--text">Max:</small> ${{
                formatNumber(item.monto_maximo)
              }}
            </div>
          </template>

          <template v-slot:[`item.id_pago_forma`]="{ item }">
            <strong>{{ item.nombre_pago_forma }}</strong>
            <br>
            {{item.nombre_titular_cuenta}}
          </template>

          <template v-slot:[`item.impuestos`]="{ item }">
            <div>
              <v-chip
                v-if="item.iva"
                class="ma-1"
                color="green"
                small
                text-color="white"
              >
                IVA: {{ formatTax(item.iva) }}%
              </v-chip>
              <v-chip
                v-if="item.isr"
                class="ma-1"
                color="red"
                small
                text-color="white"
              >
                ISR: {{ formatTax(item.isr) }}%
              </v-chip>
              <v-chip
                v-if="item.iva_retencion"
                class="ma-1"
                color="amber"
                small
                text-color="white"
              >
                IVA Ret: {{ formatTax(item.iva_retencion) }}%
              </v-chip>
              <span
                v-if="!item.iva && !item.isr && !item.iva_retencion"
                class="grey--text"
              >
                Sin impuestos
              </span>
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="openDialogAddEdit(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="openDialogDelete(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import VAlertDialog from "@/components/VAlertDialog.vue";
import VAutocompleteGastoSubtipo from '../VAutocompleteGastoSubtipo.vue';
import VAutocompletePagoForma from '../VAutocompletePagoForma.vue';

export default {
  components: {
    VAlertDialog,
    VAutocompleteGastoSubtipo,
    VAutocompletePagoForma
  },
  data: () => ({
    dialogAddEdit: false,
    dialogDelete: false,
    loading: false,
    loadingSave: false,
    loadingDelete: false,
    search: "",

    // Loading states para catálogos
    loadingProveedorTipos: false,
    loadingPersonaTipos: false,
    loadingRegimenesFiscales: false,
    loadingGastoSubtipos: false,
    loadingPagoFormas: false,
    loadingGastoTipos: false,

    // IDs conocidos para proveedor tipo
    PROVEEDOR_NACIONAL_ID: "b1921daf-3922-47ad-8a80-33a0299babe5",
    PROVEEDOR_INTERNACIONAL_ID: "733d857a-5692-40d7-b47c-dd0c70da0394",

    // IDs conocidos para proveedor tipo
    PERSONA_FISICA_ID: "fd457b15-bbf2-4d2f-be75-6cacd26f523a",
    PERSONA_MORAL_ID: "1e8548fd-a3d7-47ae-a34d-cba0ecee405c",


    // Filters
    filters: {
      id_proveedor_tipo: null,
      id_persona_tipo: null,
      id_regimen_fiscal: null,
      id_gasto_tipo: null,
      id_gasto_subtipo: null,
      id_pago_forma: null
    },

    // Catálogos
    proveedorTipos: [],
    personaTipos: [],
    regimenesFiscales: [],
    gastoTipos: [],
    gastoSubtipos: [],
    pagoFormas: [],

    headers: [
      {
        text: "Tipo Proveedor",
        value: "id_proveedor_tipo",
        align: "center",
        width: "12%",
      },
      {
        text: "Tipo Persona",
        value: "id_persona_tipo",
        align: "center",
        width: "11%",
      },
      {
        text: "Régimen Fiscal",
        value: "id_regimen_fiscal",
        align: "center",
        width: "13%",
      },
      {
        text: "Tipo Gasto",
        value: "id_gasto_subtipo",
        align: "center",
        width: "11%",
      },
      {
        text: "Rangos de Monto",
        value: "montos",
        align: "center",
        width: "13%",
      },
      {
        text: "Forma de Pago",
        value: "id_pago_forma",
        align: "center",
        width: "11%",
      },
      {
        text: "Impuestos",
        value: "impuestos",
        align: "center",
        width: "19%",
        sortable: false,
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "10%",
        sortable: false,
      },
    ],

    items: [],
    editedItem: {
      id_fiscal_regla: null,
      id_proveedor_tipo: null,
      id_persona_tipo: null,
      id_regimen_fiscal: null,
      id_gasto_tipo: null,
      id_gasto_subtipo: null,
      monto_minimo: 0.1,
      monto_maximo: 0,
      id_pago_forma: null,
      iva: "",
      isr: "",
      iva_retencion: "",
    },
    defaultEditedItem: {
      id_fiscal_regla: null,
      id_proveedor_tipo: null,
      id_persona_tipo: null,
      id_regimen_fiscal: null,
      id_gasto_tipo: null,
      id_gasto_subtipo: null,
      monto_minimo: 0.1,
      monto_maximo: 0,
      id_pago_forma: null,
      iva: "",
      isr: "",
      iva_retencion: "",
    },


  }),

  computed: {
    filteredRules() {
      let filtered = this.items;
      if (this.filters.tipoProveedor) {
        filtered = filtered.filter(
          (r) => r.id_proveedor_tipo === this.filters.tipoProveedor
        );
      }
      if (this.filters.tipoPersona) {
        filtered = filtered.filter(
          (r) => r.id_persona_tipo === this.filters.tipoPersona
        );
      }
      if (this.filters.regimenFiscal) {
        filtered = filtered.filter(
          (r) => r.id_regimen_fiscal === this.filters.regimenFiscal
        );
      }
      if (this.filters.gastoSubtipo) {
        filtered = filtered.filter(
          (r) => r.id_gasto_subtipo === this.filters.gastoSubtipo
        );
      }
      return filtered;
    },

    isProveedorNacional() {
      return this.editedItem.id_proveedor_tipo === this.PROVEEDOR_NACIONAL_ID;
    },
    
    isPersonaFisica() {
      return this.editedItem.id_persona_tipo === this.PERSONA_FISICA_ID;
    },
    

    regimenesFiscalesFiltrados() {
      if (!this.editedItem.id_persona_tipo) {
        return this.regimenesFiscales;
      }

      const personaTipo = this.personaTipos.find(
        (p) => p.id_persona_tipo === this.editedItem.id_persona_tipo
      );

      if (!personaTipo) return this.regimenesFiscales;

      const esFisica = personaTipo.nombre.toLowerCase().includes("física");
      const esMoral = personaTipo.nombre.toLowerCase().includes("moral");

      return this.regimenesFiscales.filter((regimen) => {
        if (esFisica) return regimen.persona_fisica;
        if (esMoral) return regimen.persona_moral;
        return true;
      });
    },
  },

  mounted() {
      this.getProveedorTipos();
      this.getPersonaTipos();
      this.getRegimenesFiscales();
      this.getGastoTipos();
      this.getGastoSubtipos();
      this.getPagoFormas();
      this.getItems();
  },

  methods: {
    getProveedorTipos() {
      this.loadingProveedorTipos = true;
      axios
        .get("/Proveedores/ListarProveedorTipos")
        .then((response) => {
          this.proveedorTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorTipos = false;
        });
    },

    getPersonaTipos() {
      this.loadingPersonaTipos = true;
      axios
        .get("/Proveedores/ListarPersonaTipos")
        .then((response) => {
          this.personaTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPersonaTipos = false;
        });
    },

    getRegimenesFiscales() {
      this.loadingRegimenesFiscales = true;
      axios
        .get("/Catalogos/ListarRegimenFiscales")
        .then((response) => {
          this.regimenesFiscales = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRegimenesFiscales = false;
        });
    },

     getGastoTipos() {
      this.loadingGastoTipos = true;
      axios
        .get("/Pagos/ListarGastoTiposHeaders")
        .then((response) => {
          this.gastoTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingGastoTipos = false;
        });
    },

    getGastoSubtipos() {
      this.loadingGastoSubtipos = true;
      axios
        .get("/Pagos/ListarGastoSubTipos")
        .then((response) => {
          this.gastoSubtipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingGastoSubtipos = false;
        });
    },

    getPagoFormas() {
      this.loadingPagoFormas = true;
      axios
        .get("/Pagos/ListarPagoFormas")
        .then((response) => {
          this.pagoFormas = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPagoFormas = false;
        });
    },

    getItems() {
      this.loading = true;
      axios
        .get("/Pagos/ListarFiscalReglas")
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDialogAddEdit(editItem = null) {
      if (editItem != null) {
        this.editedItem = Object.assign({}, editItem);
      } else {
        this.editedItem = Object.assign({}, this.defaultEditedItem);
      }
      this.dialogAddEdit = true;
    },

    closeDialogAddEdit() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogAddEdit = false;
    },

    saveDialogAddEdit() {
      // Validaciones
      if (
        this.editedItem.id_proveedor_tipo == null ||
        this.editedItem.id_proveedor_tipo.length === 0
      ) {
        this.$refs.alert.setMessage(
          "",
          "Debe seleccionar un Tipo de Proveedor"
        );
        this.$refs.alert.open();
        return;
      }

      if (
        this.editedItem.monto_minimo == null ||
        this.editedItem.monto_minimo < 0
      ) {
        this.$refs.alert.setMessage(
          "",
          "El Monto Mínimo debe ser mayor o igual a 0"
        );
        this.$refs.alert.open();
        return;
      }

      if (
        this.editedItem.monto_maximo == null ||
        this.editedItem.monto_maximo < this.editedItem.monto_minimo
      ) {
        this.$refs.alert.setMessage(
          "",
          "El Monto Máximo debe ser mayor que el Monto Mínimo"
        );
        this.$refs.alert.open();
        return;
      }

      if (
        this.editedItem.id_pago_forma == null ||
        this.editedItem.id_pago_forma.length === 0
      ) {
        this.$refs.alert.setMessage("", "Debe seleccionar una Forma de Pago");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      axios({
        method: this.editedItem.id_fiscal_regla === null ? "POST" : "PUT",
        url:
          this.editedItem.id_fiscal_regla === null
            ? "/Pagos/CrearFiscalRegla"
            : `/Pagos/EditarFiscalRegla/${this.editedItem.id_fiscal_regla}`,
        data: {
          id_proveedor_tipo: this.editedItem.id_proveedor_tipo,
          id_persona_tipo: this.editedItem.id_persona_tipo,
          id_regimen_fiscal: this.editedItem.id_regimen_fiscal,
          id_gasto_tipo: this.editedItem.id_gasto_tipo,
          id_gasto_subtipo: this.editedItem.id_gasto_subtipo,
          monto_minimo: this.editedItem.monto_minimo,
          monto_maximo: this.editedItem.monto_maximo,
          id_pago_forma: this.editedItem.id_pago_forma,
          iva: this.editedItem.iva,
          isr: this.editedItem.isr,
          iva_retencion: this.editedItem.iva_retencion,
        },
      })
        .then(() => {
          this.getItems();
          this.closeDialogAddEdit();
        })
        .catch((error) => {
          if (error.response && error.response.status == 409) {
            this.$refs.alert.setMessage(
              "",
              "Ya existe una regla fiscal con las mismas condiciones."
            );
            this.$refs.alert.open();
            return;
          }
          console.log(error);
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },

    openDialogDelete(editItem) {
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },

    closeDialogDelete() {
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },

    saveDialogDelete() {
      this.loadingDelete = true;
      axios
        .delete(`/Pagos/EliminarFiscalRegla/${this.editedItem.id_fiscal_regla}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },

    onProveedorTipoChange() {
      if (!this.isProveedorNacional) {
        this.editedItem.id_persona_tipo = null;
        this.editedItem.id_regimen_fiscal = null;
        this.editedItem.id_gasto_subtipo = null;
      }
    },

    onPersonaTipoChange() {
      this.editedItem.id_regimen_fiscal = null;
    },

    getProveedorColor(id) {
      return id === this.PROVEEDOR_NACIONAL_ID ? "green" : "indigo";
    },

    formatNumber(value) {
      if (!value) return "0.00";
      return new Intl.NumberFormat("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatTax(value) {
      if (!value) return "0.00";
      return new Intl.NumberFormat("es-MX", {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4,
      }).format(value);
    }
  },
};
</script>